module.exports = __webpack_public_path__ + "static/media/deleat_icon.71f33db5.svg";